module.exports = __webpack_public_path__ + "static/media/04_Development.8eb60880.png";